export const EMAIL_DOMAIN_BLACKLIST = [
  'm.expediapartnercentral.com',
  'guest.booking.com',
  'agoda-messaging.com',
  'bestday.com',
  'hoteldo.com'
]
